export const MODAL_ROLE = 'modal';
